import Box from '../../../components/box/Box';
import { BoxSection as BoxSectionParams } from '../../../models/auto-generated-strapi-types/types/components/BoxSection';
import { InnerWrapper, OuterWrapper } from './BoxSection.style';

const BoxSection: React.FC<any> = ({ data }: { data: BoxSectionParams }) => {
  const getBoxes = () => {
    return data?.boxes?.map((box) => (
      <Box
        data={box}
        personalization={data?.personalization}
        cols={data?.columnsNumber}
      />
    ));
  };

  return (
    <OuterWrapper color={data?.backgroundColor}>
      <InnerWrapper>{getBoxes()}</InnerWrapper>
    </OuterWrapper>
  );
};

export default BoxSection;
